import React from 'react';

import PropTypes from 'prop-types';

import { validateAccess } from 'common/utils/helpers';

const CheckAccess = ({ children, requiredPermissions = [] }) => {
    const hasAccess = validateAccess(requiredPermissions);

    if (!hasAccess) return null;

    return <>{hasAccess && <>{children}</>}</>;
};

CheckAccess.propTypes = {
    children: PropTypes.node,
    requiredPermissions: PropTypes.array,
};

export default CheckAccess;
